import { useState, useEffect } from "react";
import {
  Box,
  List,
  Typography,
} from "@mui/material";
import useAsyncEffect from "use-async-effect";
import ChatContainer from "./ChatContainer";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { setJobs } from "../redux/jobSlice";
import { JobsAPI } from "../apis/jobsApi";
import MessageListItem from "./MessagesListItem";
import { socket } from "../socket";

type MessagesViewProps = {
    newMessages: any[]
}
const MessagesView = ({newMessages}: MessagesViewProps) => {

  useEffect(() => {
    // connect / disconnect when this component loads
    socket.connect();

    return () => {
      socket.disconnect();
    };
  }, []);


  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();// eslint-disable-line

  const [currentJob, setCurrentJob] = useState({} as any);

  const jobs = useSelector((state: any) => state.jobs.list || []);
  // const user = useSelector((state: any) => state.user || {});

  const [filteredJobs, setFilteredJobs] = useState([] as any[]);

  const [currentMessages, setCurrentMessages] = useState([] as any[]);

  const getJobs = async () => {
    const js = await JobsAPI.listJobs();
    dispatch(setJobs(js || []));
  };

  useAsyncEffect(async () => {
    await getJobs();
  }, []);

  useEffect(() => {
    if (newMessages.length > 0) {
        addMessage(newMessages[newMessages.length-1]);
    }
    
  }, [newMessages]);  // eslint-disable-line

  const addMessage = (messageObj: any) => {
    if (currentJob.id === messageObj.jobId) {
      const newMsgs = [...currentMessages];
      newMsgs.push(messageObj);
      setCurrentMessages(newMsgs);
    }
  };

  useEffect(() => {
    const focusedJob = searchParams.get("jobId");
    const newJobs = jobs.filter(
      (j: any) => (j.messages && j.messages.length > 0) || j.id === focusedJob
    );

    if (newJobs.length > 0) {
      setCurrentJob(newJobs[0]);
      
    }
    newJobs.forEach((j: any) => {
        // listen for events for these jobs
      socket.emit("join room", j.id);
    });

    setFilteredJobs(newJobs);
  }, [jobs]); // eslint-disable-line

  useEffect(() => {
    setCurrentMessages(currentJob.messages);
  }, [currentJob])

  return (
    <Box sx={{ display: "flex", flexDirection: "row",  border: '1px none orange', width: '100vw', height: 'calc(100vh - 120px)' }}>
      <Box sx={{ width: "30%", borderRight: '1px solid #eaeaea' }}>
        <Typography sx={{width: 'calc(100% - 2rem)', background: 'none', textAlign: 'left', paddingLeft: '2rem'}}variant="h6">Messages</Typography>
        <List sx={{ border: "1px none green" }}>
          {filteredJobs.map((j: any) => {
            return (
              <MessageListItem
                key={j.id}
                job={j}
                selected={currentJob.id === j.id}
                onSelect={() => setCurrentJob(j)}
              />
            );
          })}
        </List>
      </Box>

      <ChatContainer job={currentJob} messages={currentMessages} />
    </Box>
  );
};

export default MessagesView;
